module.exports = (__parcel__import__("2HwWE")).then(() => parcelRequire('8OYBW'));